// extracted by mini-css-extract-plugin
export default {"subSubtitle":"styles_subSubtitle__lDEjP"};